"use client";

import type { IconProp } from "@fortawesome/fontawesome-svg-core";
import type { ProductsQuery } from "~/app/[lang]/(default)/category/[id]/ProductsGrid";
import { FastFilterButton } from "./FastFilterButton";

interface Props {
	aggregations: ProductsQuery["aggregations"];
	items: {
		title: string;
		icon: IconProp;
		code: string;
		options: string[];
		query: Record<string, string>;
	}[];
}

export function FastFilters({ aggregations, items }: Props) {
	const hasFilters = aggregations.some((aggregation) =>
		items.some((item) => {
			return (
				aggregation.attribute_code === item.code &&
				aggregation.options.some((option) => !!option.label && item.options.includes(option.label))
			);
		}),
	);

	if (!hasFilters) {
		return null;
	}

	return (
		<div className="flex shrink-0 space-x-4">
			<span className="h-5 w-px shrink-0 self-center bg-shades" />

			{items.map((item, index) => {
				const aggregation = aggregations.find((a) => a.attribute_code === item.code);

				const options = aggregation?.options.filter((option) => {
					if (option.label) {
						return item.options.includes(option.label);
					}
				});

				if (aggregation && options?.length) {
					return (
						<FastFilterButton
							title={item.title}
							icon={item.icon}
							query={item.query}
							aggregation={aggregation}
							options={options}
							key={index}
						/>
					);
				}
			})}
		</div>
	);
}
